<template>
  <div class="home">
    <EmployeePositionList v-show="listView" @newPosition="onClickNewFromList" @editPosition="onClickEditFromList" ref="refreshList"/>
    <EmployeePositionForm v-show="formView" :position="position" @backClicked="onBackChild" @backParentID="backParentID"/>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
import EmployeePositionList from '@/components/employee/EmployeePositionList.vue'
import EmployeePositionForm from '@/components/employee/EmployeePositionForm.vue'
import { getHeader, employeeUrl } from '../config'

export default {
  name: 'EmployeeGrade',
  components: {
    EmployeePositionList,
    EmployeePositionForm
  },
  data () {
    return {
      listView: true,
      formView: false,
      position: {
        id: null,
        name: null,
        company_no: null
      }
    }
  },
  methods: {
    backParentID: function (id) {
      axios.get(employeeUrl + '/position/' + id, { headers: getHeader() })
        .then(response => {
          this.listView = false
          this.formView = true
          this.position = response.data.data
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    onClickEditFromList: function (value) {
      this.listView = false
      this.formView = true
      this.position = value
    },
    getEdit: function (value) {
      console.log(employeeUrl + '/position/' + value)
      axios.get(employeeUrl + '/position/' + value, { headers: getHeader() })
        .then(response => {
          console.log(response.data.data)
          this.listView = false
          this.formView = true
          this.position = response.data.data
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    onClickNewFromList: function () {
      this.listView = false
      this.formView = true
      this.position = {
        id: null,
        name: null,
        company_no: null
      }
    },
    onBackChild: function () {
      this.listView = true
      this.formView = false
      this.position = {
        id: null,
        name: null,
        company_no: null
      }
      this.$refs.refreshList.refreshList()
      // this.$router.replace({ path: 'sales', query: null })
    }
  },
  mounted () {
    this.$store.dispatch('getEmployeeDepartment')
    this.$store.dispatch('getRowTable')
  }
}
</script>
